import { render, staticRenderFns } from "./Calltoaction.vue?vue&type=template&id=35cc6657&scoped=true"
import script from "./Calltoaction.vue?vue&type=script&lang=js"
export * from "./Calltoaction.vue?vue&type=script&lang=js"
import style0 from "./Calltoaction.vue?vue&type=style&index=0&id=35cc6657&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35cc6657",
  null
  
)

export default component.exports